<template>
  <el-menu
    :default-active="activeIndex2"
    class="el-menu-demo"
    mode="horizontal"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
    @select="handleSelect"
  >
    <router-link to="/">
      <el-menu-item index="1">Home</el-menu-item>
    </router-link>

    <el-sub-menu index="2">
      <template #title>Admin</template>
      <router-link to="create-stock">
        <el-menu-item index="2-1">添加黑名单</el-menu-item>
      </router-link>
      <router-link to="create-population">
        <el-menu-item index="2-2">添加城市数据</el-menu-item>
      </router-link>
    </el-sub-menu>
    <router-link to="about">
      <el-menu-item index="4">About</el-menu-item>
    </router-link>
    <router-link to="tech">
      <el-menu-item index="3">Tech</el-menu-item>
    </router-link>
  </el-menu>
</template>

<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const activeIndex = ref("1");
    const activeIndex2 = ref("1");
    const handleSelect = (key, keyPath) => {
      console.log(key, keyPath);
    };
    return {
      activeIndex,
      activeIndex2,
      handleSelect,
    };
  },
});
</script>

<style scoped>
a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}
</style>